import { useState, useEffect } from "react";
import EditIcon from "@mui/icons-material/Edit";
import { Box, Tooltip, IconButton, InputBase, Typography } from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseSupplierProduct } from "./UseSupplierProduct";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { deCapitalizeFirstLetter } from "../../util/Utils";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import CheckIcon from "@mui/icons-material/Check";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

export default function SuppliersList() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const navigate = useNavigate();
  const { getSupplierProductList } = UseSupplierProduct();
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC("CompanyName");
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );

  const [supplierProductRes, setSupplierProductRes] = useState();

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    getSupplierProductList(
      myPc,
      search,
      (supplierProducts) => {
        if (msGotoLast) {
          setMsGotoLast(false);
          goToLastPage(supplierProducts.pageCondition.totalPage);
          return;
        }
        setSupplierProductRes(supplierProducts);
      },
      true
    );
  }, [myPc]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const newFunc = () => {
    return navigate("/supplierProducts/addSupplierProduct", {
      state: {
        myPc: myPc,
        search: search,
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },
    {
      field: "companyName",
      headerName: "نام شرکت",
      width: 170,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.companyName}
          </Typography>
        );
      },
    },
    {
      field: "visitor",
      headerName: "نام ویزیتور",
      width: 170,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.visitor ? cellValues.row.visitor : "-"}
          </Typography>
        );
      },
    },
    {
      field: "visitorMobile",
      headerName: "شماره ویزیتور",
      width: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.visitorMobile ? cellValues.row.visitorMobile : "-"}
          </Typography>
        );
      },
    },
    {
      field: "companyMobile",
      headerName: "شماره شرکت",
      width: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.companyMobile ? cellValues.row.companyMobile : "-"}
          </Typography>
        );
      },
    },

    {
      field: "isEnable",
      headerName: "وضعیت",
      width: 80,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Box>
            {cellValues.row.isEnable ? (
              <CheckIcon style={{ color: "#618833" }} />
            ) : (
              <CloseOutlinedIcon style={{ color: "red" }} />
            )}
          </Box>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 100,
      align: "center",
      headerAlign: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Tooltip title="Edit">
            <IconButton
              onClick={() => {
                setScrollTo(cellValues.api.getScrollPosition());

                return navigate("/supplierProducts/editSupplierProduct", {
                  state: {
                    model: cellValues.row,
                    myPc: myPc,
                    search: search,
                    id: cellValues.row.id,
                  },
                });
              }}
            >
              <EditIcon sx={{ color: "MyColor.main" }} />
            </IconButton>
          </Tooltip>
        );
      },
    },
    {
      field: "search",
      width: 200,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "بازرگانی",
        childs: [{ name: msActiveMenu.pageTitle, url: "/supplierproducts" }],
      }}
    >
      {supplierProductRes ? (
        <DataGrid
          disableVirtualization
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={supplierProductRes.pageCondition.pageCount}
          rows={supplierProductRes.items}
          paginationMode="server"
          page={supplierProductRes.pageCondition.page - 1}
          onPageChange={(page) => {
            updatePage(page + 1);
          }}
          rowCount={supplierProductRes.pageCondition.totalItemCount}
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              scrollTo: myPc.scrollTo,
              newFunc: newFunc,
              nofab: true,
              rowCount: supplierProductRes.pageCondition.totalItemCount,
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: deCapitalizeFirstLetter(myPc.sortColumn),
                  sort: deCapitalizeFirstLetter(myPc.sortOrder),
                },
              ],
            },
            pagination: {
              page: myPc.page,
            },
          }}
          onSortModelChange={(model) => {
            updateSort(model[0].field, model[0].sort == "asc" ? "asc" : "desc");
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
